import { createSlice } from '@reduxjs/toolkit';
import { IReduxState } from '../../interfaces/IReduxState';
import { ISlotList } from '../../../Pages/Slot/ISlot';

interface IUpdate extends IReduxState<ISlotList> {
  fixupdateableDate?: ISlotList;
}

export const UpdateFixtureSlicer = createSlice({
  name: 'UpdateFixture',
  initialState: {
    data: {},
    isLoading: false,
    updateableDate: {},
  } as IUpdate,
  reducers: {
    updateFixture: (state, _) => {
      state.isLoading = true;
    },
    successUpdateFixture: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    failureUpdateFixture: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    FixturesUpdateableData: (state, action) => {
      state.fixupdateableDate = action.payload;
    },
    clearUpdateFixtureState: (state) => {
      state.data = {};
      state.fixupdateableDate = undefined;
    },
    clearUpdateableData: (state) => {
      state.fixupdateableDate = undefined;
    },
  },
});

export const {
  updateFixture,
  failureUpdateFixture,
  successUpdateFixture,
  FixturesUpdateableData,
  clearUpdateFixtureState,
  clearUpdateableData,
} = UpdateFixtureSlicer.actions;

export default UpdateFixtureSlicer.reducer;
